/**
 * Форматирование экранов EXONN и писем E-Post. Суммы приходят из центра в центах.
 */

export type Tone = "success" | "info" | "warning" | "error" | "grey";

export const formatCents = (cents: number | null | undefined): string => {
  if (cents === null || cents === undefined) {
    return "—";
  }

  // Один знак минуса во всей странице — типографский.
  return (cents / 100)
    .toLocaleString("de-DE", { style: "currency", currency: "EUR" })
    .replace("-", "−");
};

/** «16.10.2026 05:25 MESZ» → «16.10. 05:25» для узкой колонки. */
export const shortDateTime = (berlin: string): string =>
  `${berlin.slice(0, 6)} ${berlin.slice(11, 16)}`;
